export const isUnknownTrace = (id) => !id || id === "unknown";

export const formatDuration = (ms) => {
  if (ms === null || ms === undefined || isNaN(ms)) return "—";
  const n = Number(ms);
  if (n < 1000) return `${n}ms`;
  if (n < 60000) return `${(n / 1000).toFixed(1)}s`;
  const mins = Math.floor(n / 60000);
  const secs = Math.round((n % 60000) / 1000);
  return `${mins}m ${String(secs).padStart(2, "0")}s`;
};

export const formatDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleString();
};

export const toLocalDatetimeString = (isoString) => {
  if (!isoString) return "";
  const date = new Date(isoString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const toUTCISOString = (localDatetime) => {
  if (!localDatetime) return undefined;
  const date = new Date(localDatetime);
  return date.toISOString();
};

export const EVENT_TYPE_META = {
  form_submitted: { icon: "edit_note", pillClass: "form", label: "Form" },
  pa_job: { icon: "manufacturing", pillClass: "activity", label: "Job" },
  http_call: { icon: "swap_horiz", pillClass: "http", label: "HTTP" },
  validation: { icon: "rule", pillClass: "validation", label: "Validation" },
  activity_action: { icon: "play_arrow", pillClass: "default", label: "Action" }
};

export const STATUS_OPTIONS = [
  { value: "", label: "All statuses" },
  { value: "success", label: "Success" },
  { value: "validation_failed", label: "Validation failed" },
  { value: "job_failed", label: "Job failed" }
];

export const statusPillClass = (status) => {
  switch (status) {
    case "success":
      return "success";
    case "validation_failed":
      return "validation_failed";
    case "job_failed":
    case "failed":
      return "job_failed";
    case "running":
      return "running";
    case "skipped":
      return "skipped";
    default:
      return "default";
  }
};

export const buildReportText = (header, events, screenOpen) => {
  const line = (label, value) => `${label.padEnd(11)}${value ?? "—"}`;
  const lines = [
    `AUDIT REPORT — trace ${header?.trace_id}`,
    line("Actor:", `${header?.user_email || "—"} (${header?.user_id || "—"})`),
    line("Workflow:", `${header?.wf_name || "—"} (${header?.wf_id || "—"})`),
    line(
      "Activity:",
      `${header?.activity_name || header?.activity_id || "—"}   Instance: ${header?.instance_id || "—"}`
    ),
    line(
      "Status:",
      `${header?.status || "—"}   Duration: ${formatDuration(header?.duration_ms)}   Started: ${header?.started_at || "—"}   Completed: ${header?.completed_at || "—"}`
    )
  ];
  if (header?.error) lines.push(line("Error:", header.error));
  if (screenOpen?.screen_name || screenOpen?.created_at) {
    lines.push(
      line(
        "Screen:",
        `${screenOpen?.screen_name || "—"} opened ${screenOpen?.created_at || "—"} from ${screenOpen?.ip_address || "—"}`
      )
    );
  }
  lines.push("Timeline:");
  (events || []).forEach((e, i) => {
    const parts = [
      `[${e.event_type}]`,
      e.stage_label || "—",
      `— ${e.status || "—"}`,
      `— ${formatDuration(e.duration_ms)}`
    ];
    if (e.message) parts.push(`— ${e.message}`);
    lines.push(`  ${i + 1}. ${parts.join(" ")}`);
  });
  lines.push(`Link: ${window.location.href}`);
  return lines.join("\n");
};
